import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import "@fortawesome/fontawesome-free/css/all.min.css";
import Header from './component/Header';
import HeroSection from './component/HeroSlider';
import Footer from './component/Footer';
import About from './pages/About';
import TermsConditions from './pages/TermsConditions';
import PrivacyPolicy from './pages/PrivacyPolicy';
import ServiceSection from './pages/ServiceSection';
import Ourfleet from './pages/Ourfleet';
import Packages from './pages/Packages';
import ContactInfoSection from './pages/ContactInfoSection';
import Enquiry from './pages/Enquiry';
import Blog from './pages/Blog';
import Gallery from './pages/Gallery';
import Booking from './pages/Booking';
import BookPunetonashikcab from './pages/Book Pune To Nashik Cab';
import BookPunetoganpatipulecab from './pages/Book Pune To Ganpatipule Cab';
import Bookpunetoratnagiricab from './pages/Book Pune To Ratnagiri Cab';
import Bookpunetodevkundcab from './pages/Book Pune To Devkund Cab';
import Bookpunetogoacabtaxi from './pages/Book Pune To Goa Cab Taxi';
import Bookpunetokohlapurcab from './pages/Book Pune To Kolhapur Cab';
import Bookpunetolonavalacab from './pages/Book Pune To Lonavala Cab';
import Bookpunetoalibaugcab from './pages/Book Pune To Alibaug Cab';
import Bookpunetoaurangabadcab from './pages/Book Pune To Aurangabad Cab';
import Bookpunetobhimashankarcab from './pages/Book Pune To Bhimashankar Cab';
import BookMurusjanjiracabfrompune from './pages/Book Murud Janjira Cab From Pune';
import Bookpunetoadlabsimagicacab from './pages/Book Pune To Adlabs Imagica Cab';
import Bookpunetomahabaleshwercab from './pages/Book Pune To Mahabaleshwar Cab';
import Bookpunetotrimkeshwercab from './pages/Book Pune To Trimbakeshwar Cab';
import Punemumbaipuneroundtrip from './pages/Pune Mumbai Pune Round Trip';
import Mumbaipunepickupdrop from './pages/Mumbai Pune Pickup Drop';
import Outstationcabsfrompune from './pages/Outstation Cabs From Pune';
import Busserviceinpune from './pages/Bus Service In Pune';
import Jyotilingayatrafrompune from './pages/12 Jyotirlinga Yatra from Pune';
import Punetogrishneshwercabservice from './pages/Pune To Grishneshwar Cab Services';
import Punetomalshejghatccab from './pages/Pune To Malshej Ghat Cab';
import Punetopandharpurcabservice from './pages/Pune To Pandharpur Cab Service';
import Punetopanhalafortcabservice from './pages/Pune To Panhala Fort Cab Service';
import Punetoraigharfortcabservice from './pages/Pune To Raigad Fort Cab Service';
import Punetosatarakaspatharcab from './pages/Pune To Satara Kas Pathar Cab';
import Punetoshirdicabpickupdrop from './pages/Pune To Shirdi Cab Pickup Drop';
import Punetotarkarlicarrental from './pages/Pune To Tarkarli Car Rental';
import Punetotuljapurcabbooking from './pages/Pune To Tuljapur Cab Booking';
import Punetovanisaptashrungi from './pages/Pune To Vani Saptashrungi Cab Booking';
import Punetoaundhanathcabservice from './pages/Pune To Aundha Nagnath Cab Service';
import Punetoashtavinayakcabservice from './pages/Pune To Ashtavinayak Cab Service';
import Sadetinshaktipeethyatrafrompune from './pages/Sadhitin Shaktipeeth Yatra From Pune';
import Innovacabsbookinginpune from './pages/Innova Cabs Booking in Pune';
import Punetomahabaleshwerinnovacab from './pages/Pune to Mahabaleshwar Innova Cab';
import Bookinnovaforoutstationfrompune from './pages/Book Innova for Outstation From Pune';
import Punetomumbaiairportinnova from './pages/Pune to Mumbai Airport Innova';
import Innovacabforcorporateoffice from './pages/Innova Cab for Corporate Office';
import Mumbaiairporttopuneinnovacabs from './pages/Mumbai Airport to Pune Innova Cabs';
import Punetoshirdiinnovacarrental from './pages/Pune to Shirdi Innova Car Rental';
import Punetoaurangabadinnovacab from './pages/Pune Aurangabad Innova Cab Service';
import Punetogoainnovacabbooking from './pages/Pune to Goa Innova Cab Booking';
import Punetobangloreinnovacab from './pages/Pune to Bangalore Innova Cab';
import Punetohyderabadinnovarentalcab from './pages/Pune to Hyderabad Innova Rental Cab';
import ScrollToTop from './component/ScrollToTop';
import Corporatecabserviceinpune from './pages/Corporate cab service in Pune';
import Monthlycabserviceinpune from './pages/Monthly cab service in Pune';
import Cabsforcorporateevent from './pages/Cabs for corporate events';
import Cabsforcorporateofficesinpune from './pages/Cabs for corporate offices in Pune';
import Mumbaicabservice from './pages/Mumbai cab service';
import Mumbaitoshirdicab from './pages/Mumbai to Shirdi cab service';
import Mumbaitobhimashankarcab from './pages/Mumbai to Bhimashankar cab';
import Mumbaitogoacab from './pages/Mumbai to Goa cab';
import Navimumbaitogoacab from './pages/Navi Mumbai to Goa cab';
import Mumbaitokohlapur from './pages/Mumbai to Kolhapur cab';
import Mumbaiairportcab from './pages/Mumbai Airport cab';
import Mumbaitomahabaleshwercab from './pages/Mumbai to Mahabaleshwar Cab';
import Mumbaitopanchganicab from './pages/Mumbai to Panchgani cab';
import Mumbaitokonkandarshan from './pages/Mumbai to Konkan Darshan';
import Mumbaionlinecabbooking from './pages/Mumbai Online Cab Booking';
import Mumbaitotrimbakeshwercab from './pages/Mumbai to Trimbakeshwar cab';
import Mumbaitolonavala from './pages/Mumbai to Lonavala cab';
import Mumbaitobanglorecab from './pages/Mumbai to Bangalore cab';
import Mumbaitohyderabadcab from './pages/Mumbai to Hyderabad Cab';
import Punetooutstationcab from './pages/Pune outstation cab';
import Punetoayodhyacab from './pages/Pune to Ayodhya Cab';
import Punetoprayagrajcab from './pages/Pune to Prayagraj cab';
import Mumbaitosambhajinagar from './pages/Mumbai to Sambhajinagar';
import Goatomumbaicab from './pages/Goa to Mumbai Cab';
import Goatopunecab from './pages/Goa to Pune cab';
import Goatonavimumbaicab from './pages/Goa to Navi Mumbai Cab';
import Goatothaneacab from './pages/Goa to Thane cab';
import Goatopimprichichwad from './pages/Goa to Pimpri Chinchwad cab';
import Urbaniaonrentinpune from './pages/Urbania on rent in Pune';
import Urbaniaonrentinmumbai from './pages/Urbania on rent in Mumbai';
import Tempotravelleronrentinpune from './pages/Tempo Traveller on rent in Pune';
import Tempotravelleronrentinmumbai from './pages/Tempo Traveller on rent in Mumbai';
import Corporatecabserviceinmumbai from './pages/Corporate cab service in Mumbai';
import Weddingcarrentalinpune from './pages/Wedding car rental in Pune';
import Weedingcarrentalinmumbai from './pages/Wedding car rental in Mumbai';
import Mumbaitooutstationcab from './pages/Mumbai to Outstation Cab';
import Mumbaitoashtavinayakdarshancab from './pages/Mumbai to Ashtavinayak Darshan cab';
import Mumbaitojyotilingadarshancab from './pages/Mumbai to 5 Jyotirlinga Darshan cab';
import Innovacrystahireinmumbai from './pages/Innova Crysta Hire In Mumbai';
import Cabserviceinnavimumbai from './pages/Cab Service In Navi Mumbai';
import Mumbaitonashikcab from './pages/Mumbai to Nashik cab';
import Mumbaidarshancab from './pages/Mumbai Darshan Cab';
import ContactButtons from './component/ContactButtons';
import BookTaxiPage from './pages/BookTaxiPage';
import Punetomumbaicabs from './pages/Pune to Mumbai Cabs';
import Mumbaitogoacabs from './pages/Mumbai to Pune Cabs';
import Mumbaitopuneairportcab from './pages/Mumbai to Pune Airport Cab';
import Mumbaiairporttopunecab from './pages/Mumbai airport to Pune Cab';
import Punetoshirdicab from './pages/Pune to Shirdi Cab';
import Shirditopunecab from './pages/Shirdi to Pune Cab';
import Shirditomumbaicab from './pages/Shirdi to Mumbai Cab';
import Kolhapurtopunecab from './pages/Kolhapur to Pune cab';
import Puneairportcabservice from './pages/Pune Airport Cab Service';
import Nashikcabservice from './pages/Nashik Cab Service';
import Mumbaioutstationcab from './pages/Mumbai Outstation Cabs';
import Nashikcab from './pages/Pune to Nashik Cab';
import Punetomahabaleshwercab from './pages/Pune to Mahabaleshwar cab';
import Punetokolhapurcab from './pages/Pune to Kolhapur cab';
import Punetogoacab from './pages/Pune to Goa Cabs';
import usePageTracking from './pages/usePageTracking';
// import { useLocation } from "react-router-dom";

// import CaptchaScreen from './component/CaptchaScreen';
function App() {
//   const [showCaptcha, setShowCaptcha] = useState(false);
//   const [verified, setVerified] = useState(false);

//   useEffect(() => {
//   const visits = parseInt(localStorage.getItem("visitCount") || "0");
//   if (visits >= 5) {  
//     setShowCaptcha(true);
//     localStorage.setItem("visitCount", "0"); 
//   } else {
//     localStorage.setItem("visitCount", visits + 2);
//   }
// }, []);


//   if (showCaptcha && !verified) {
//     return <CaptchaScreen onVerified={() => setVerified(true)} />;
//   }





  return (
    <Router>
      <Header />
      <ContactButtons/>
      <ScrollToTop/>

      <Routes>

        <Route path="/" element={<HeroSection />} />
        <Route path="/about" element={<About />} />
        <Route path="/book-taxi" element={<BookTaxiPage />} />
        <Route path="/term-condition" element={<TermsConditions />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/services" element={<ServiceSection />} />
        <Route path="/our-fleet" element={<Ourfleet />} />
        <Route path="/packages" element={<Packages />} />
        <Route path="/contact-us" element={<ContactInfoSection />} />
        <Route path="/enquiry" element={<Enquiry />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/booking" element={<Booking />} />
        <Route path="/Book-Pune-To-Nashik-Cab" element={<BookPunetonashikcab />} />
        {/* <Route path="/Pune-To-Nashik-Cab" element={<BookPunetonashikcab />} /> */}
        <Route path="/Pune-To-Ganpatipule-Cab" element={<BookPunetoganpatipulecab />} />
           <Route path="/Pune-To-Ratnagiri-Cab" element={<Bookpunetoratnagiricab />} />
        <Route path="/Pune-To-Devkund-Cab" element={<Bookpunetodevkundcab />} />
        <Route path="/Pune-To-Goa-Cab-Taxi" element={<Bookpunetogoacabtaxi />} />
          <Route path="/Book-Pune-To-Kolhapur-Cab" element={<Bookpunetokohlapurcab />} />
          <Route path="/Pune-To-Lonavala-Cab" element={<Bookpunetolonavalacab />} />
          <Route path="/Pune-To-Alibaug-Cab" element={<Bookpunetoalibaugcab />} />
          <Route path="/Pune-To-Aurangabad-Cab" element={<Bookpunetoaurangabadcab />} />
          <Route path="/Pune-To-Bhimashankar-Cab" element={<Bookpunetobhimashankarcab />} />
          <Route path="/Murud-Janjira-Cab-From-Pune" element={<BookMurusjanjiracabfrompune />} />
          <Route path="/Pune-To-Adlabs-Imagica-Cab" element={<Bookpunetoadlabsimagicacab />} />
          <Route path="/Book-Pune-To-Mahabaleshwar-Cab" element={<Bookpunetomahabaleshwercab />} />
          <Route path="/Pune-To-Trimbakeshwar-Cab" element={<Bookpunetotrimkeshwercab />} />
          <Route path="/Pune-Mumbai-Pune-Round-Trip" element={<Punemumbaipuneroundtrip />} />
           <Route path="/Mumbai-Pune-Pickup-Drop" element={<Mumbaipunepickupdrop />} />

           <Route path="/Outstation-Cabs-From-Pune" element={<Outstationcabsfrompune />} />
            <Route path="/Bus-Service-In-Pune" element={<Busserviceinpune />} />
            <Route path="/12-Jyotirlinga-Yatra-From-Pune" element={<Jyotilingayatrafrompune />} />
            <Route path="/Pune-To-Grishneshwar-Cab-Services" element={<Punetogrishneshwercabservice />} />
            <Route path="/Pune-To-Malshej-Ghat-Cab" element={<Punetomalshejghatccab />} />
            <Route path="/Pune-To-Pandharpur-Cab-Service" element={<Punetopandharpurcabservice />} />
            <Route path="/Pune-To-Panhala-Fort-Cab-Service" element={<Punetopanhalafortcabservice />} />
            <Route path="/Pune-To-Raigad-Fort-Cab-Service" element={<Punetoraigharfortcabservice />} />
            <Route path="/Pune-To-Satara-Kas-Pathar-Cab" element={<Punetosatarakaspatharcab />} />
            <Route path="/Pune-To-Shirdi-Cab-Pickup-Drop" element={<Punetoshirdicabpickupdrop />} />
            <Route path="/Pune-To-Tarkarli-Car-Rental" element={<Punetotarkarlicarrental />} />
            <Route path="/Pune-To-Tuljapur-Cab-Booking" element={<Punetotuljapurcabbooking />} />
            <Route path="/Pune-To-Vani-Saptashrungi-Cab-Booking" element={<Punetovanisaptashrungi/>} />

            <Route path="/Pune-To-Aundha-Nagnath-Cab-Service" element={<Punetoaundhanathcabservice />} />
<Route path="/Pune-To-Ashtavinayak-Cab-Service" element={<Punetoashtavinayakcabservice />} />
<Route path="/Sadhitin-Shaktipeeth-Yatra-From-Pune" element={<Sadetinshaktipeethyatrafrompune />} />
<Route path="/Innova-Cabs-Taxi-Booking-in-Pune" element={<Innovacabsbookinginpune />} />
<Route path="/Pune-to-Mahabaleshwar-Innova-Cab" element={<Punetomahabaleshwerinnovacab />} />
<Route path="/Book-Innova-for-Outstation-From-Pune" element={<Bookinnovaforoutstationfrompune />} />
<Route path="/Pune-to-Mumbai-Airport-Innova" element={<Punetomumbaiairportinnova />} />
<Route path="/Innova-Cab-for-Corporate-Office" element={<Innovacabforcorporateoffice />} />
<Route path="/Mumbai-Airport-to-Pune-Innova-Cabs" element={<Mumbaiairporttopuneinnovacabs />} />
<Route path="/Pune-to-Shirdi-Innova-Car-Rental" element={<Punetoshirdiinnovacarrental />} />
<Route path="/Pune-Aurangabad-Innova-Cab-Service" element={<Punetoaurangabadinnovacab />} />
<Route path="/Pune-to-Goa-Innova-Cab-Booking" element={<Punetogoainnovacabbooking />} />
<Route path="/Pune-to-Bangalore-Innova-Cab" element={<Punetobangloreinnovacab />} />
<Route path="/Pune-to-Hyderabad-Innova-Rental-Cab" element={<Punetohyderabadinnovarentalcab />} />
<Route path="/Corporate-Cab-Service-in-Pune" element={<Corporatecabserviceinpune />} />
<Route path="/Monthly-Cab-Service-in-Pune" element={<Monthlycabserviceinpune />} />
<Route path="/Cabs-for-Corporate-Events" element={<Cabsforcorporateevent />} />
<Route path="/Cabs-for-Corporate-Offices-in-Pune" element={<Cabsforcorporateofficesinpune />} />
<Route path="/Mumbai-Cab-Service" element={<Mumbaicabservice />} />
<Route path="/Mumbai-to-Shirdi-Cab-Service" element={<Mumbaitoshirdicab />} />
<Route path="/Mumbai-to-Bhimashankar-Cab" element={<Mumbaitobhimashankarcab />} />
<Route path="/Mumbai-to-Goa-Cab" element={<Mumbaitogoacab />} />
<Route path="/Navi-Mumbai-to-Goa-Cab" element={<Navimumbaitogoacab />} />
<Route path="/Mumbai-to-Kolhapur-Cab" element={<Mumbaitokohlapur />} />

<Route path="/Mumbai-Airport-Cab" element={<Mumbaiairportcab />} />
<Route path="/Mumbai-to-Mahabaleshwar" element={<Mumbaitomahabaleshwercab />} />
<Route path="/Mumbai-to-Panchgani-Cab" element={<Mumbaitopanchganicab />} />
<Route path="/Mumbai-to-Konkan-Darshan" element={<Mumbaitokonkandarshan />} />
<Route path="/Mumbai-Online-Cab-Booking" element={<Mumbaionlinecabbooking />} />
<Route path="/Mumbai-to-Trimbakeshwar-Cab" element={<Mumbaitotrimbakeshwercab />} />
<Route path="/Mumbai-to-Lonavala-Cab" element={<Mumbaitolonavala />} />
<Route path="/Mumbai-to-Bangalore-Cab" element={<Mumbaitobanglorecab />} />
<Route path="/Mumbai-to-Hyderabad-Cab" element={<Mumbaitohyderabadcab />} />
<Route path="/Pune-Outstation-Cab" element={<Punetooutstationcab />} />

<Route path="/Pune-to-Ayodhya-Cab" element={<Punetoayodhyacab />} />
<Route path="/Pune-to-Prayagraj-cab" element={<Punetoprayagrajcab />} />
<Route path="/Mumbai-to-Sambhajinagar-Cab" element={<Mumbaitosambhajinagar />} />
<Route path="/Goa-to-Mumbai-Cab" element={<Goatomumbaicab />} />
<Route path="/Goa-to-Pune-Cab" element={<Goatopunecab />} />
<Route path="/Goa-to-Navi-Mumbai-Cab" element={<Goatonavimumbaicab />} />
<Route path="/Goa-to-Thane-Cab" element={<Goatothaneacab />} />
<Route path="/Goa-to-Pimpri-Chinchwad-Cab" element={<Goatopimprichichwad />} />
<Route path="/Urbania-on-Rent-in-Pune" element={<Urbaniaonrentinpune />} />
<Route path="/Urbania-on-Rent-in-Mumbai" element={<Urbaniaonrentinmumbai />} />

<Route path="/Tempo-Traveller-on-Rent-in-Pune" element={<Tempotravelleronrentinpune />} />
<Route path="/Tempo-Traveller-on-Rent-in-Mumbai" element={<Tempotravelleronrentinmumbai />} />
<Route path="/Corporate-Cab-Service-in-Mumbai" element={<Corporatecabserviceinmumbai />} />
<Route path="/Wedding-Car-Rental-in-Pune" element={<Weddingcarrentalinpune />} />
<Route path="/Wedding-Car-Rental-in-Mumbai" element={<Weedingcarrentalinmumbai />} />
<Route path="/Mumbai-to-Outstation-Cab" element={<Mumbaitooutstationcab />} />
<Route path="/Mumbai-to-Ashtavinayak-Darshan-Cab" element={<Mumbaitoashtavinayakdarshancab />} />
<Route path="/Mumbai-to-5-Jyotirlinga-Darshan-Cab" element={<Mumbaitojyotilingadarshancab />} />
<Route path="/Innova-Crysta-Hire-In-Mumbai" element={<Innovacrystahireinmumbai />} />
<Route path="/Cab-Service-In-Navi-Mumbai" element={<Cabserviceinnavimumbai />} />
<Route path="/Mumbai-to-Nashik-Cab" element={<Mumbaitonashikcab />} />
<Route path="/Mumbai-Darshan-Cab" element={<Mumbaidarshancab />} />
<Route path="/Pune-to-Mumbai-Cabs" element={<Punetomumbaicabs />} />
<Route path="/Mumbai-to-Pune-Cabs" element={<Mumbaitogoacabs />} />
<Route path="/Mumbai-to-Pune-Airport-Cab" element={<Mumbaitopuneairportcab />} />
<Route path="/Mumbai-airport-to-Pune-Cab" element={<Mumbaiairporttopunecab />} />
<Route path="/Pune-to-Shirdi-Cab" element={<Punetoshirdicab />} />
<Route path="/Shirdi-to-Pune-Cab" element={<Shirditopunecab />} />
<Route path="/Shirdi-to-Mumbai-Cab" element={<Shirditomumbaicab />} />
<Route path="/Kolhapur-to-Pune-cab" element={<Kolhapurtopunecab />} />
<Route path="/Pune-Airport-Cab-Service" element={<Puneairportcabservice />} />
<Route path="/Nashik-Cab-Service" element={<Nashikcabservice />} />
<Route path="/Mumbai-Outstation-Cabs" element={<Mumbaioutstationcab />} />
<Route path="/Pune-to-Nashik-Cab" element={<Nashikcab />} />
<Route path="/Pune-to-Mahabaleshwar-cab" element={<Punetomahabaleshwercab />} />
<Route path="/Pune-to-Kolhapur-cab" element={<Punetokolhapurcab />} />
<Route path="/Pune-to-Goa-Cabs" element={<Punetogoacab />} />


      </Routes>
     <Footer/>
    </Router>
  );
}

function PageTracker() {
  usePageTracking();
  return null;
}

export default App;
